// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"5248eb36","487":"39975f65","707":"e7d29a76"}[chunkId] + ".chunk.js";
};